module.exports = __webpack_public_path__ + "static/media/mic_muted.24af6ba7.svg";